import React from 'react';
import { BrowserRouter as Router, Route, Routes,Navigate } from 'react-router-dom';
import LoginPage from '../Login/Login.js';
import Forgotpassword from '../Login/Forgotpassword.js';
import ResetPwd from '../Login/Resetpassword.js'
import Dashboard from '../Dashboard/Dashboard.js'; 
import Maintainentity from '../Entities/MaintainEntity.js';
import EntityTypes from '../Entities/EntityTypes.js';
import BaseCompany from '../Entities/BaseCompany.js';
import MessageType from '../Messages/MessageTypes.js';
import Routingstatus from '../Messages/RoutingStatus.js';
import Statuscode from '../Messages/StatusCode.js';
import Mappingstream from '../Messages/MappingStream.js';
import SourceEndpoint from '../Endpoints/SourceEndpoint.js';
import EndpointType from '../Endpoints/EndPointTypes.js';
import HandlingTracks from '../Alerts/HandlingTracks.js';
import Categories from '../Alerts/Categories.js';
import AlertTypes from '../Alerts/AlertTypes.js';
import Latency from '../Others/LatencyTypes.js';
import MessageScreen from '../Others/MessageScreenTypes.js';
import LogRecords from '../Others/LogRecords.js';
import StatsByTbNumber from '../Others/StatsByTbNumber.js'
import Statistics from '../Others/Statistics.js'
import Support from '../Support/Support.js';
import {MainLayout} from '../Routes/MainLayout.js'; 
import PublicRoute from '../Routes/PublicRoute'; 
import PrivateRoute from '../Routes/PrivateRoute.js'; 
import { basename } from '../../Config.js';

function Navigation() {
  return (
    <Router basename={basename}>
        <Routes>
           <Route path="/login" element={ <PublicRoute><LoginPage /></PublicRoute>} />
           <Route path="/forgot-password" element={<PublicRoute><Forgotpassword /></PublicRoute> } />
           <Route path="/reset-password" element={<PublicRoute><ResetPwd /></PublicRoute>} />
           <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/maintainentity" element={<Maintainentity />} />
            <Route path="/entity_types" element={<EntityTypes />} />
            <Route path="/base_company" element={<BaseCompany />} />
            <Route path="/message_types" element={<MessageType />} />
            <Route path="/routing_status" element={<Routingstatus />} />
            <Route path="/staus_code" element={<Statuscode />} />
            <Route path="/mapping_stream" element={<Mappingstream />} />
            <Route path="/Source_Endpoint" element={<SourceEndpoint />} />
            <Route path="/endpoint_type" element={<EndpointType />} />
            <Route path="/handling_tracks" element={<HandlingTracks />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/alert_types" element={<AlertTypes />} />
            <Route path="/latency_types" element={<Latency />} />
            <Route path="/message_routing" element={<MessageScreen />} />
            <Route path="/log_records" element={<LogRecords />} />
            <Route path="/stats_Tbnumber" element={<StatsByTbNumber />} />
            <Route path="/Statistics" element={<Statistics />} />
            <Route path="/Support" element={<Support />} />
            </Route>
            </Routes>
    </Router>
  );
}

export default Navigation;
